(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["camisudo-video-commerce"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('camisudo-video-commerce')) {
    customElements.define('camisudo-video-commerce', class CamisudoVideoCommerce extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.trigger = this.querySelector('.camisudo-video-commerce__trigger');
        this.dialog = this.querySelector('dialog');
        if (!this.trigger || !this.dialog) return;
        this.initialized = true;
        this.listeners = new AbortController();
        const options = {signal: this.listeners.signal};
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        this.previewReady = false;
        this.previewPending = false;
        this.dismissed = false;
        try {
          this.dismissed = sessionStorage.getItem(`camisudo-video-${this.id}`) === 'hidden';
        } catch (error) {}
        this.hidden = this.dismissed;

        this.trigger.addEventListener('click', () => this.openVideo(), options);
        this.querySelector('.camisudo-video-commerce__close')?.addEventListener('click', () => this.closeVideo(), options);
        this.querySelector('.camisudo-video-commerce__dismiss')?.addEventListener('click', () => this.dismiss(), options);
        this.querySelector('.camisudo-video-commerce__cta')?.addEventListener('click', () => {
          this.track('video_cta_clicked');
          this.closeVideo(false);
          const kit = document.querySelector('kit-builder');
          if (typeof kit?.focusFirstIncomplete === 'function') {
            kit.focusFirstIncomplete();
          } else {
            (kit || document.querySelector('product-info, .product'))?.scrollIntoView({
              behavior: this.motion.matches ? 'auto' : 'smooth', block: 'start',
            });
          }
        }, options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.closeVideo();
        }, options);
        this.dialog.addEventListener('cancel', () => this.player?.pause(), options);
        this.dialog.addEventListener('close', () => {
          this.releaseVideo('player');
          if (this.restoreTriggerFocus !== false && !this.dismissed) this.trigger.focus({preventScroll: true});
          this.restoreTriggerFocus = true;
          this.syncPlayback();
        }, options);
        document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
        this.motion.addEventListener('change', () => this.syncPlayback(), options);
        this.connection?.addEventListener?.('change', () => this.syncPlayback(), options);
        window.addEventListener('resize', () => this.updateStickyOffset(), options);

        this.observedStickies = new Set();
        if ('ResizeObserver' in window) {
          this.stickyObserver = new ResizeObserver(() => this.updateStickyOffset());
        }

        this.overlayObserver = new MutationObserver(() => {
          this.syncStickyBars();
          this.syncPlayback();
        });
        this.overlayObserver.observe(document.documentElement, {
          subtree: true, childList: true, attributes: true, attributeFilter: ['open', 'class', 'aria-expanded', 'hidden'],
        });
        this.syncStickyBars();
        this.previewVisible = !('IntersectionObserver' in window);
        if ('IntersectionObserver' in window) {
          this.previewObserver = new IntersectionObserver((entries) => {
            const entry = entries.find((item) => item.target === this.trigger);
            if (!entry) return;
            this.previewVisible = entry.isIntersecting;
            this.syncPlayback();
          }, {threshold: 0.1});
          this.previewObserver.observe(this.trigger);
        }
        this.schedulePreview = () => {
          if (this.dismissed) return;
          const ready = () => {
            this.previewIdle = null;
            this.previewTimer = null;
            this.previewReady = true;
            this.syncPlayback();
          };
          if ('requestIdleCallback' in window) {
            this.previewIdle = window.requestIdleCallback(ready, {timeout: 2000});
          } else {
            this.previewTimer = window.setTimeout(ready, 1200);
          }
        };
        if (document.readyState === 'complete') this.schedulePreview();
        else window.addEventListener('load', this.schedulePreview, {...options, once: true});
      }

      syncStickyBars() {
        if (!this.initialized) return;
        const stickies = new Set(document.querySelectorAll('.kit-builder__sticky'));
        for (const sticky of this.observedStickies) {
          if (!stickies.has(sticky)) this.stickyObserver?.unobserve(sticky);
        }
        for (const sticky of stickies) {
          if (!this.observedStickies.has(sticky)) this.stickyObserver?.observe(sticky);
        }
        this.observedStickies = stickies;
        this.updateStickyOffset();
      }

      updateStickyOffset() {
        if (!this.initialized) return;
        let offset = 0;
        for (const sticky of this.observedStickies) {
          if (sticky.hidden || !sticky.isConnected) continue;
          const styles = window.getComputedStyle(sticky);
          if (styles.display === 'none' || styles.visibility === 'hidden') continue;
          const rect = sticky.getBoundingClientRect();
          if (rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight) {
            offset = Math.max(offset, window.innerHeight - rect.top);
          }
        }
        const value = `${Math.ceil(offset)}px`;
        if (this.style.getPropertyValue('--camisudo-sticky-offset') !== value) {
          this.style.setProperty('--camisudo-sticky-offset', value);
        }
      }

      isDataConstrained() {
        return Boolean(this.connection?.saveData) || ['slow-2g', '2g'].includes(this.connection?.effectiveType);
      }

      hasOtherOverlay() {
        return Array.from(document.querySelectorAll('dialog[open]')).some((dialog) => dialog !== this.dialog)
          || Boolean(document.querySelector('cart-drawer.active, cart-notification.active, .drawer.active, menu-drawer details[open], header-drawer details[open]'))
          || document.documentElement.classList.contains('camisudo-fitter-open');
      }

      syncPlayback() {
        if (!this.initialized) return;
        const blocked = this.dismissed || this.hidden || document.hidden || this.hasOtherOverlay();
        if (blocked) this.player?.pause();
        const dataConstrained = this.isDataConstrained();
        const canPreview = !blocked && !this.dialog.open && !this.motion.matches && !dataConstrained && this.previewVisible && this.previewReady;
        if (!canPreview) {
          this.preview?.pause();
          if (dataConstrained || !this.previewVisible) this.releaseVideo('preview');
          return;
        }
        if (!this.preview) {
          const template = this.querySelector('[data-video-preview]');
          if (!template) return;
          this.preview = template.content.querySelector('video').cloneNode(true);
          this.preview.muted = true;
          this.preview.playsInline = true;
          this.preview.hidden = true;
          this.preview.tabIndex = -1;
          this.preview.setAttribute('aria-hidden', 'true');
          const preview = this.preview;
          preview.addEventListener('playing', () => {
            preview.hidden = false;
            this.syncPlayback();
          }, {signal: this.listeners.signal});
          preview.addEventListener('pause', () => { preview.hidden = true; }, {signal: this.listeners.signal});
          template.parentElement.appendChild(preview);
        }
        if (this.preview.paused && !this.previewPending) {
          this.previewPending = true;
          Promise.resolve(this.preview.play()).catch(() => {}).finally(() => {
            this.previewPending = false;
          });
        }
      }

      openVideo() {
        if (this.dismissed || document.hidden || this.dialog.open || this.hasOtherOverlay()) return;
        this.preview?.pause();
        if (!this.player) {
          const template = this.querySelector('[data-video-player]');
          this.player = template.content.querySelector('video').cloneNode(true);
          template.parentElement.appendChild(this.player);
        }
        this.restoreTriggerFocus = true;
        this.dialog.showModal();
        this.querySelector('.camisudo-video-commerce__close')?.focus({preventScroll: true});
        this.track('video_opened');
        this.player.play().catch(() => {});
      }

      closeVideo(restoreFocus = true) {
        this.player?.pause();
        if (this.dialog?.open) {
          this.restoreTriggerFocus = restoreFocus;
          this.dialog.close();
        }
      }

      releaseVideo(key) {
        const video = this[key];
        if (!video) return;
        video.pause();
        video.removeAttribute('src');
        video.querySelectorAll('source').forEach((source) => source.removeAttribute('src'));
        video.load();
        video.remove();
        this[key] = null;
      }

      cancelPreview() {
        if (this.previewIdle != null) window.cancelIdleCallback(this.previewIdle);
        if (this.previewTimer != null) window.clearTimeout(this.previewTimer);
        this.previewIdle = null;
        this.previewTimer = null;
      }

      dismiss() {
        this.dismissed = true;
        this.hidden = true;
        this.cancelPreview();
        this.closeVideo();
        this.releaseVideo('preview');
        this.releaseVideo('player');
        try {
          sessionStorage.setItem(`camisudo-video-${this.id}`, 'hidden');
        } catch (error) {}
      }

      track(name) {
        document.dispatchEvent(new CustomEvent('camisudo:interaction', {detail: {name, source: 'video'}}));
      }

      disconnectedCallback() {
        this.initialized = false;
        this.cancelPreview();
        this.listeners?.abort();
        this.overlayObserver?.disconnect();
        this.previewObserver?.disconnect();
        this.stickyObserver?.disconnect();
        this.observedStickies?.clear();
        this.closeVideo();
        this.releaseVideo('preview');
        this.releaseVideo('player');
        this.style.removeProperty('--camisudo-sticky-offset');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
